import { ToastrService } from 'ngx-toastr';
import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { LocalService } from 'src/app/services/local.service';
import { GrupoLocalNivelService } from 'src/app/services/grupo-local-nivel.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { APP_SETTINGS } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { CommandResult } from '../../domain/commandResult';
import { GrupoLocalNivel1, Local } from '../../domain/domain.model';

@Component({
  selector: 'app-local',
  templateUrl: './local.component.html',
  styleUrls: ['./local.component.scss'],
  providers: [LocalService]
})
export class LocalComponent implements OnInit, AfterContentInit {

  constructor(
    private localService: LocalService,
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder,
    private grupoLocalNivelService: GrupoLocalNivelService,
    private toastr: ToastrService
  ) { }

  public cadastrados: Local[] = [];
  public niveis1: GrupoLocalNivel1[] = [];


  public form: FormGroup = null;

  public isEditing = false;
  public isProcessing = false;
  public isLoading = false;

  public autorizacoes: UsuarioAutorizacoes;

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('local');
  }

  ngOnInit() {
    this.resetForm(); // instancia o formulário utilizado (formGroup)
    this.getAllGrupoLocalNivel1();
  }


  getAllGrupoLocalNivel1() {
    this.grupoLocalNivelService.getAllGrupoLocalNivel1().subscribe(
      (response: GrupoLocalNivel1[]) => {
        this.niveis1 = response;
      }
    );
  }


  public resetForm(): void {
    this.form = this.formBuilder.group(
      {
        id: [0],
        tipoLocal: [APP_SETTINGS.tipoLocal],
        nome: [null, [Validators.required]],
        codigo: [null, [Validators.required]],
        grupoLocalNivel1Id: ['', [Validators.required]],
      }
    );
  }

  public resetParcial() {

    // Limpa o formuláio, mas mantém dos dados de grupo local
    // para adição de novos locais
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoading = false;

    this.form.patchValue({
      id: 0,
      nome: null,
      codigo: null
    })

    this.form.markAsUntouched();
  }

  public getById(id: number): void {

    this.resetParcial();
    this.isProcessing = true;

    this.localService.getById(id).subscribe(

      (response: Local) => {
        this.form.patchValue({
          id: response.id,
          nome: response.nome,
          codigo: response.codigo,
          grupoLocalNivel1Id: response.grupoLocalNivel1Id
        })

        //this.form.get('tipoLocal').setValue(response.tipoLocal);

        this.isEditing = true;

      },
      (exception: any) => {
        this.showErrorExecption(exception);
        this.isProcessing = false
      },
      () => this.isProcessing = false
    );
  }

  public submit(): void {

    if (this.validForm()) {

      this.isProcessing = true;

      if (this.form.get('id').value === 0) {
        this.localService.isUniqueNomeLocal(this.form.get('nome').value).subscribe(

          (isUniqueNomeLocal: boolean) => {

            if (isUniqueNomeLocal) {

              if (this.form.get('tipoLocal').value === 2 && this.form.get('id').value === 0) {

                this.localService.isUniqueCodigoSubstacao(this.form.get('codigo').value).subscribe(

                  (isUniqueCodigoSubstacao: boolean) => {

                    if (isUniqueCodigoSubstacao) {
                      this.save();
                    } else {
                      this.form.get('codigo').setErrors({ isNotUniqueCodigoSubstacao: true });
                      this.isProcessing = false;
                    }
                  },
                  (exception: any) => {
                    const cmdResult = new CommandResult(false, '', [], null);
                    cmdResult.showErrorExecption(exception);
                  }
                );
              } else {
                this.save();
              }
            } else {
              this.form.get('nome').setErrors({ isNotUniqueNomeLocal: true });
              this.isProcessing = false;
            }
          },
          (exception: any) => {
            const cmdResult = new CommandResult(false, '', [], null);
            cmdResult.showErrorExecption(exception);
          }
        );
      } else {
        this.save();
      }
    }
  }

  public validForm() {
    if (this.form.get('grupoLocalNivel1Id').value == null || this.form.get('grupoLocalNivel1Id').value === '') {
      this.form.get('grupoLocalNivel1Id').setErrors({ hasGrupoLocalNivelNaoInformado: true });
      return false;
    }

    return true;
  }
  public save() {

    this.localService.create(this.form.value).subscribe(

      (response: CommandResult) => {

        if (response.success === true) {

          if (response.data.codigo) {
            this.toastr.success(response.message);
            this.resetParcial();
            this.getCadastrados();
          } else {
            this.update(response.data);
          }
        } else {
          this.toastr.error(response.message);
        }
      },
      (exception: any) => {
        this.showErrorExecption(exception);
        this.isProcessing = false
      },
      () => this.isProcessing = false
    );

  }

  public update(local: any) {

    local.codigo = `000${local.id}`.substr(-4,4);

    this.localService.create(local).subscribe(
      (response: CommandResult) => {

        if (response.success === true) {
          this.toastr.success(response.message);
          this.resetParcial();
          this.getCadastrados();
        } else {
          this.toastr.error(response.message);
        }
      },
      (exception: any) => {
        this.showErrorExecption(exception);
        this.isProcessing = false
      },
      () => this.isProcessing = false
    );
  }

  public questionDelete(id: number) {
    Swal({
      title: 'Excluir',
      text: 'Deseja excluir o item selecionado?',
      type: 'question',
      showCancelButton: true,
      cancelButtonText: 'Não',
      showConfirmButton: true,
      confirmButtonText: 'Sim',
      cancelButtonColor: '#d33',
      focusCancel: true
    }).then((result) => {
      if (result.value) {
        this.delete(id);
      }
    });

  }


  private delete(id: number): void {
    this.isProcessing = true;
    this.localService.delete(id).subscribe(
      (response: CommandResult) => {
        const cmdResult = new CommandResult(response.success, response.message, response.notifications, response.data);
        if (cmdResult.success === true) {
          cmdResult.showSucess();
          this.resetParcial();
          this.getCadastrados();
        } else {
          cmdResult.showError();
        }
      },
      (exception: any) => {
        const cmdResult = new CommandResult(false, '', [], null);
        cmdResult.showErrorExecption(exception);
      },
      () => this.isProcessing = false
    );
  }


  getCadastrados() {

    this.cadastrados = []
    this.isLoading = true;

    const grupoLocalNivel1Id = Number(this.form.get('grupoLocalNivel1Id').value);

    if (grupoLocalNivel1Id > 0) {

      this.localService.getLocaisByGrupoLocalNivelId(grupoLocalNivel1Id).subscribe(
        (response: Local[]) => {
          this.cadastrados = response;
          this.isLoading = false;
        },
        (exception: any) => {
          const cmdResult = new CommandResult(false, '', [], null);
          cmdResult.showErrorExecption(exception);
        },
        () => this.isLoading = false

      );
    }

  }

  private showErrorExecption(exception: any) {
    let msg = exception.message;
    if (Number(exception.status) === 0) { msg = 'A aplicação não conseguiu se conectar ao Servidor'; }
    if (Number(exception.status) === 500) { msg = 'O Servidor gerou um erro de processamento'; }
    this.toastr.error(`<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`);
  }

  getNextCodigo() {
    this.localService.getNextId().subscribe(
      (response: any) => {
        this.form.get('codigo').setValue(response.result);
      }
    );
  }

}
